var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.028 6.717a1.548 1.548 0 0 1 2.489-.168l.123.168.622.977a7.76 7.76 0 0 0 2.378 2.378l.977.622a1.548 1.548 0 0 1 0 2.612l-.977.622a7.76 7.76 0 0 0-2.378 2.378l-.622.977a1.548 1.548 0 0 1-2.612 0l-.622-.977a7.75 7.75 0 0 0-2.378-2.378l-.977-.622a1.548 1.548 0 0 1 0-2.612l.977-.622a7.76 7.76 0 0 0 2.378-2.378zm1.066 2.05a9.76 9.76 0 0 1-2.992 2.993l-.378.24.378.24a9.76 9.76 0 0 1 2.992 2.992l.24.377.24-.377a9.76 9.76 0 0 1 2.992-2.992l.377-.24-.377-.24a9.76 9.76 0 0 1-2.992-2.992l-.24-.378z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.334 1c6.075 0 11 4.925 11 11s-4.925 11-11 11-11-4.925-11-11 4.925-11 11-11m0 2a9 9 0 1 0 0 18 9 9 0 0 0 0-18",
    clipRule: "evenodd"
  })));
};
export default Svg24;